import React from 'react';
import { STUDIO_COPY } from '../config';

const STEPS = [
  {
    title: STUDIO_COPY.customizeHowStep1Title,
    body: STUDIO_COPY.customizeHowStep1Body,
  },
  {
    title: STUDIO_COPY.customizeHowStep2Title,
    body: STUDIO_COPY.customizeHowStep2Body,
  },
  {
    title: STUDIO_COPY.customizeHowStep3Title,
    body: STUDIO_COPY.customizeHowStep3Body,
  },
  {
    title: STUDIO_COPY.customizeHowStep4Title,
    body: STUDIO_COPY.customizeHowStep4Body,
  },
  {
    title: STUDIO_COPY.customizeHowStep5Title,
    body: STUDIO_COPY.customizeHowStep5Body,
  },
  {
    title: STUDIO_COPY.customizeHowStep6Title,
    body: STUDIO_COPY.customizeHowStep6Body,
  },
  {
    title: STUDIO_COPY.customizeHowStep7Title,
    body: STUDIO_COPY.customizeHowStep7Body,
  },
] as const;

/**
 * Thorough "How it works" guide for Customize.
 * Desktop: persistent left panel. Mobile/PWA: collapsible accordion.
 */
const CustomizeHowItWorks: React.FC = () => {
  return (
    <aside
      className="studio-customize-how"
      data-testid="studio-customize-how"
      aria-label={STUDIO_COPY.customizeHowTitle}
    >
      <details className="studio-customize-how-panel" open>
        <summary
          className="studio-customize-how-title"
          data-testid="studio-customize-how-summary"
        >
          <span>{STUDIO_COPY.customizeHowTitle}</span>
          <span className="studio-customize-how-chevron" aria-hidden="true">
            ▾
          </span>
        </summary>
        <ol
          className="studio-customize-how-list"
          data-testid="studio-customize-how-list"
        >
          {STEPS.map((step, index) => (
            <li key={step.title}>
              <span className="studio-customize-how-num" aria-hidden="true">
                {index + 1}
              </span>
              <div className="studio-customize-how-copy">
                <p className="studio-customize-how-step-title">{step.title}</p>
                <p className="studio-customize-how-step-body">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </details>
    </aside>
  );
};

export default CustomizeHowItWorks;
